module.exports = __webpack_public_path__ + "media/images/icon-getcovered-f1a24d33d220e7638160ce72e82a07f3.png";